import { render, staticRenderFns } from "./RegistrationActiveView.vue?vue&type=template&id=2fdc2702&scoped=true"
import script from "./RegistrationActiveView.vue?vue&type=script&lang=js"
export * from "./RegistrationActiveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdc2702",
  null
  
)

export default component.exports